export default {
  faq: {
    idwg: {
      question: 'Why did I get an IDWG alert?',
      answer:
        'You may receive a lighter notice for IDWG from 1% to less than 4% of your dry weight. These notices do not interrupt the app. IDWG of 4% or more triggers the full alert. Open the notification to see the guidance for your band.',
    },
    meal: {
      question: 'How do I log a meal?',
      answer:
        'Open Diet Diary or tap “Log a meal” on Home, add a photo and press “Add this meal”. The AI estimates nutrition and shows tips. You can save up to 3 meals per day, including deleted meals.',
    },
    dryWeight: {
      question: 'What is my dry weight?',
      answer:
        'It’s the weight your care team aims for after dialysis, when extra fluid has been removed. When your care team updates it, you can review the update in the app.',
    },
    careTeam: {
      question: 'Can my care team see my entries?',
      answer:
        'Yes. Authorised NKF clinical staff can view your fluid, symptom, diet and mood check-ins to support your care.',
    },
    reminders: {
      question: 'How do reminders work?',
      answer:
        'Set weight and BP reminders under More → Reminder Settings, and medicine reminders under Medication Reminders. You can switch each one on or off.',
    },
    language: {
      question: 'How do I change the language?',
      answer:
        'Use the language button on the Login page, or change it in your Profile. English and 中文 are available.',
    },
  },
};
